import { Button, Box, Typography, Container, Divider } from "@mui/material";
import { RefreshOutlined, ExitToApp } from "@mui/icons-material";
import { handleLogout } from "_sirius/src/actions/action_helpers";
import i18n from "i18next";

export function ApolloProviderFallback() {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Container maxWidth="md" sx={{ mt: 12 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          p: 6,
          borderRadius: 1,
          border: "1px solid",
          borderColor: "divider",
          bgcolor: "background.paper",
        }}
      >
        <Typography
          variant="h5"
          component="h1"
          gutterBottom
          sx={{ fontWeight: 400, mb: 3 }}
        >
          Unable to Load User Data
        </Typography>

        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ mb: 1, maxWidth: 500 }}
        >
          There was an issue loading your user information. This could be due to
          a temporary service interruption, system maintenance, or account
          activation status.
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Please try refreshing the page or contact your administrator if the
          issue persists.
        </Typography>

        <Divider sx={{ width: "100%", mb: 4 }} />

        <Box sx={{ display: "flex", gap: 3 }}>
          <Button
            variant="contained"
            startIcon={<RefreshOutlined />}
            onClick={handleRefresh}
            sx={{
              textTransform: "none",
              px: 3,
              py: 1.5,
            }}
          >
            Refresh Page
          </Button>

          <Button
            variant="text"
            startIcon={<ExitToApp />}
            onClick={handleLogout}
            sx={{
              textTransform: "none",
              px: 3,
              py: 1.5,
            }}
          >
            {i18n.t("nav_bar.log_out")}
          </Button>
        </Box>

        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ mt: 4, fontStyle: "italic" }}
        >
          If your account needs activation, please contact your system
          administrator
        </Typography>
      </Box>
    </Container>
  );
}
